import "./Sidnavbar.scss";

import * as React from "react";
import { styled, Theme, CSSObject, useTheme } from "@mui/material/styles";
// import { styled, Theme, CSSObject, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Button,
  CircularProgress,
  Collapse,
  ListSubheader,
  Paper,
  Popover,
  SvgIcon,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Stack,
  Avatar,
  Divider,
  Card,
} from "@mui/material";
import { listUserPackage } from "../../Redux/Slices/UserPackage/ListUserPackageSlice";
import { IMenuItem } from "./ISidnavbar";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import { ReactComponent as Subscription } from "../../Assets/Images/Subscribe.svg";
import { ReactComponent as MiniLogo } from "../../Assets/Images/MiniLogo.svg";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import IconButtonField from "../Button/IconButtonField";
import Avatars from "../Avatar/Avatars";
import IsActiveLink from "./IsActiveLink";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import SearchPopup from "./Search";
import Menus from "../Menu/Menu";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { decode } from "../../Utils/encodeDecode";
// import { IUserMaster } from "../../Pages/UserMaster/IUserMaster";
import { setTheme } from "../../Utils/setTheme";
import { themeUpdate } from "../../Redux/Slices/Theme/ThemeSlice";
import { ReactComponent as Sidenavslidericon } from "../../Assets/Images/Sidenavsilder.svg";
import { ILoginResponse } from "../../Pages/Login/ILogin";
import { clearListuser } from "../../Redux/Slices/User/ListUserSlice";
import { clearDashboardChart, dashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import UserProfileSection from "../UserProfileSection/UserProfileSection";
import {
  clearListSubscription,
  listSubscription,
} from "../../Redux/Slices/Subscription/ListSubscriptionSlice";
import { AddSubscription } from "../../Redux/Slices/Subscription/AddSubscriptionSlice";

import { ReactComponent as MobileLogo } from "../../Assets/Images/logomobile.svg";
import PricingDialog from "../PricingDialog/PricingDialog";
// import PricingDialog from "../PricingDialog/PricingDialog";
import { ReactComponent as Dashboard } from "../../Assets/Images/Dashboard.svg";
import { ReactComponent as ExamModel } from "../../Assets/Images/ExamModel.svg";
import { ReactComponent as Userpackage } from "../../Assets/Images/Userpackage.svg";
import { ReactComponent as QuestionType } from "../../Assets/Images/QuestionType.svg";
import { ReactComponent as Masters } from "../../Assets/Images/Masters.svg";
import { ReactComponent as Role } from "../../Assets/Images/Role.svg";
import { ReactComponent as Menu } from "../../Assets/Images/Menu.svg";
import { ReactComponent as UserPermission } from "../../Assets/Images/UserPermission.svg";
import { ReactComponent as PracticeTest } from "../../Assets/Images/PracticeTest.svg";
import { ReactComponent as Skilltrainer } from "../../Assets/Images/skilltrainer.svg";
import { ReactComponent as History } from "../../Assets/Images/History.svg";
import { ReactComponent as Video } from "../../Assets/Images/Videos.svg";
import { ReactComponent as Dashboarduser } from "../../Assets/Images/Dashboarduser.svg";
import { ReactComponent as Exam } from "../../Assets/Images/Exam.svg";
import { ReactComponent as Courses } from "../../Assets/Images/Courses.svg";
import { ReactComponent as PackageUser } from "../../Assets/Images/PackageUser.svg";
import { ReactComponent as Questions } from "../../Assets/Images/Questions.svg";
import { ReactComponent as Settings } from "../../Assets/Images/Settings.svg";
import { ReactComponent as Booklet } from "../../.MODULS/BOOKLET_MODUL/assets/images/study-material.svg";
import { ReactComponent as Cart } from "../../.MODULS/BOOKLET_MODUL/assets/images/cart.svg";
import { ReactComponent as Note } from "../../.MODULS/BOOKLET_MODUL/assets/images/lesson-plan.svg";
import { ReactComponent as Chat } from "../../Assets/Images/chat with eliot.svg";
import { ReactComponent as Support } from "../../Assets/Images/support.svg";
import { ReactComponent as User } from "../../Assets/Images/Userpackage.svg";



// ⚠️ Temporary arrangement until ported to Vite:
// Reverting to manual import matching pattern.
/*
const svgContext = (require as any).context(
  '../../Assets/Images', // folder path
  false,              // no subfolders (true if you want them)
  /\.svg$/            // only .svg files
);

const svgs: Record<string, string> = {};

svgContext.keys().forEach((key: any) => {
  const fileName = key.replace("./", "").replace(".svg", "");
  svgs[fileName] = svgContext(key);
});
*/

// console.log("SVGS", svgs);

/*
// Helper component for dynamic SVG styling via CSS Masks
const SidebarIcon = ({ src, className }: { src: string; className?: string }) => (
  <div
    className={className}
    style={{
      backgroundColor: "currentColor",
      mask: `url(${src}) no-repeat center`,
      WebkitMask: `url(${src}) no-repeat center`,
      maskSize: "contain",
      WebkitMaskSize: "contain",
      display: "inline-block",
    }}
  />
);
*/

// 🔧 Icon Mapping helper
const getDynamicIcon = (iconName: string | any) => {
  if (typeof iconName !== "string") return iconName;

  // Map API icon strings to their SVG components
  // These names should match what the backend sends in 'screen_icon'
  // chage this setup?
  const iconMap: { [key: string]: React.ReactNode } = {
    "Dashboard": <SvgIcon component={Dashboard} inheritViewBox />,
    "ExamModel": <SvgIcon component={ExamModel} inheritViewBox />,
    "Userpackage": <SvgIcon component={Userpackage} inheritViewBox />,
    // "YearGroup": <SvgIcon component={QuestionType} inheritViewBox />,
    "Masters": <SvgIcon component={Masters} inheritViewBox />,
    "Settings": <SvgIcon component={Settings} inheritViewBox />,
    "Role": <SvgIcon component={Role} inheritViewBox />,
    "Menu": <SvgIcon component={Menu} inheritViewBox />,
    "UserPermission": <SvgIcon component={UserPermission} inheritViewBox />,
    "PracticeTest": <SvgIcon component={PracticeTest} inheritViewBox />,
    "Skilltrainer": <SvgIcon component={Skilltrainer} inheritViewBox />,
    "History": <SvgIcon component={History} inheritViewBox />,
    "Video": <SvgIcon component={Video} inheritViewBox />,
    "Dashboarduser": <SvgIcon component={Dashboarduser} inheritViewBox />,
    "Exam": <SvgIcon component={Exam} inheritViewBox />,
    "Courses": <SvgIcon component={Courses} inheritViewBox />,
    "PackageUser": <SvgIcon component={PackageUser} inheritViewBox />,
    "QuestionType": <SvgIcon component={QuestionType} inheritViewBox />,
    "Questions": <SvgIcon component={Questions} inheritViewBox />,
    "Booklet": <SvgIcon component={Booklet} inheritViewBox />,
    "Cart": <SvgIcon component={Cart} inheritViewBox />,
    "Note": <SvgIcon component={Note} inheritViewBox />,
    "Chat": <SvgIcon component={Chat} inheritViewBox />,
    "Support": <SvgIcon component={Support} inheritViewBox />,
    "Videopage": <SvgIcon component={Video} inheritViewBox />,
    "chat": <SvgIcon component={Chat} inheritViewBox />,
    "support": <SvgIcon component={Support} inheritViewBox />,
    "videopage": <SvgIcon component={Video} inheritViewBox />,
    "Videos": <SvgIcon component={Video} inheritViewBox />,
    "videos": <SvgIcon component={Video} inheritViewBox />,
    "User": <SvgIcon component={User} inheritViewBox />,

  };

  return iconMap[iconName] || <SvgIcon component={Dashboard} inheritViewBox />;
};

const drawerWidth = 250;


const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  // background: "#F8F9FA",
  borderRight: "1px solid #e5e7eb",

  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  background: "#F8F9FA",
  border: "none",
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
  smBreackPoint?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open, smBreackPoint }) => ({
  backgroundColor: "#FFFFFF",
  color: "black",
  boxShadow: "none",
  zIndex: theme.zIndex.drawer + (smBreackPoint ? 0 : 1),
  width: smBreackPoint ? "100%" : "calc(100% - 65px)",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open &&
    !smBreackPoint && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const IconWithDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer() {
  const nav = useNavigate();

  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isUCAT = window.location.hostname.split(".")[0]?.includes("ucat");
  const [openPricing, setOpenPricing] = React.useState(false);
  const [pricingChecked, setPricingChecked] = React.useState(false);
  // main drawer open
  const [open, setOpen] = React.useState(true);
  // mobile drawer open
  const [mobileOpen, setMobileOpen] = React.useState(false);
  // mobile screen break point by mui
  const smBreackPoint = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  // user details
  // const [userDetails, setUserDetails] = React.useState<IUserMaster>();
  // theme state
  const [themeSettingsOpen, setThemeSettingsOpen] =
    React.useState<boolean>(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerOpen = () => {
    smBreackPoint ? handleDrawerToggle() : setOpen(!open);
  };

  React.useEffect(() => {
    if (smBreackPoint) {
      setOpen(true);
    }
  }, [setOpen, smBreackPoint]);

  // React.useEffect(() => {
  //   const details = decode(sessionStorage.getItem("details"));
  //   if (details) {
  //     setUserDetails(details);
  //   }
  // }, []);

  const { data: menu } = useAppSelector((state) => state.SideMenuPermission);
  const [moblieDrawerOpen, setMoblieDrawerOpen] = React.useState(false);

  // drawer menu list
  const drawer = (
    <List>
      {menu &&
        Object.keys(menu).map((keyName, key) => {
          return (
            <React.Fragment key={key}>
              {open && keyName !== "Dashboard" && keyName !== "Navigation" && (
                <ListSubheader component="div" className="listSubHeader">
                  {keyName}
                </ListSubheader>
              )}

              {/* {menu[keyName].map((item, key) => {
                return (
                  item?.permissions?.show &&
                  item?.permissions?.view && (
                    <MenuItems
                      key={key}
                      item={item}
                      mini={!open}
                      setMobileOpen={setMobileOpen}
                    />
                  )
                );
              })} */}
              {menu[keyName].map((item, index) => {
                const hasVisibleChildren = item.items?.some(
                  (child) => child.permissions?.show && child.permissions?.view
                );
                const shouldShowParent =
                  item.permissions?.view &&
                  (item.permissions?.show || hasVisibleChildren);

                return (
                  shouldShowParent && (
                    <React.Fragment key={index}>
                      {/* {item.title === "Dashboard" && open && (
                        <div className="Topicstudent">LEARN</div>
                      )} */}
                      {item.title === "Chat with Elliot" && open && (
                        <div
                          className="Topicstudent"
                          style={{ marginTop: "30px" }}
                        >
                          HELP
                        </div>
                      )}
                      <MenuItems
                        item={item}
                        mini={!open}
                        setMobileOpen={setMobileOpen}
                        setMoblieDrawerOpen={setMoblieDrawerOpen}
                      />
                    </React.Fragment>
                  )
                );
              })}
            </React.Fragment>
          );
        })}
    </List>
  );

  // search dialog open
  const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
  const [details, setDetails] = React.useState<ILoginResponse>({});
  React.useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);
  const loginResponse = useAppSelector((state) => state.LoginSlicer);

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );

  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];
  // path name
  const pathNameMap: any = {
    "/dashboard": "Dashboard",
    "/practicetest": "Practice Test",
    "/mockexam": "Mini Mock Exam",
    "/minimockexam": "Mock Exam",
    "/mainexam": "Exam",
    "/examprogress": "Exam in Progress",
    "/examhistory": "Exam History",
    "/skillstrainer": "Skills Trainer",
    "/memorygame": "Memory Game",
    "/totalexam": "My Enrollments",
    "/subscribedPages": "My Enrollments / Package",
    "/setting": "Settings",
    "/tutorials": "Video Tutorials",
    "/videolessons": "Video Lessons",
  };

  const location = useLocation();
  const currentPath: any = location.pathname;
  const mainRef = React.useRef<HTMLDivElement>(null);

  const pageTitle = pathNameMap[currentPath] || "Page";

  React.useEffect(() => {
    dispatch(dashboardChart());
  }, [dispatch]);
  const { data: DashboardCards } = useAppSelector(
    (state) => state.DashboardChart
  );

  // ...existing code...
  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (mainRef.current) {
      mainRef.current.scrollTop = 0;
    }
  }, [location.pathname]);
  // ...existing code...

  const { data: listUserPackageSlice } = useAppSelector(
    (state) => state.ListUserPackageSlice
  );
  const Packages: any = Array.isArray(listUserPackageSlice?.data)
    ? listUserPackageSlice?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];
  const Dashboarduser: any = DashboardCards?.data;

  // Subscription list
  const { data: SubscriptionSlice, isLoading: scriptionSlice } = useAppSelector(
    (state) => state.ListSubscriptionSlice
  );
  const Subcriptiondetails: any = SubscriptionSlice;

  const { isLoading: addingSubscription } = useAppSelector(
    (state) => state.AddSubscriptionSlice
  );

  const isSubscriptionProcessing = addingSubscription || scriptionSlice || Subcriptiondetails?.status === true;

  // Check if user is admin
  const current_role = details?.role?.toUpperCase();
  const dashboardPath = current_role === "ADMIN" ? "/admindashboard" : current_role == "STUDENT" ? "/dashboard" : "/tutor_dashboard";

  React.useLayoutEffect(() => {
    if (Subcriptiondetails?.status === true) {
      nav("/subscribedPages");
    }
  }, [Subcriptiondetails, nav]);

  React.useEffect(() => {
    dispatch(listUserPackage());
  }, [dispatch]);

  // scroll bar issus

  const mainSectionRef = React.useRef<HTMLDivElement>(null);

  // Scroll to top on route change
  React.useEffect(() => {
    if (mainSectionRef.current) {
      mainSectionRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <CssBaseline />
      {/*     Header     */}
      {/* <AppBar
        position="fixed"
        open={open}
        smBreackPoint={smBreackPoint}
        className="app_bar"
      >
        <Toolbar
          sx={{
            gap: "8px",
          }}
        >

          {smBreackPoint ? (
            <IconButton
              className="navigate_icon_button"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{}}
            >
              <MenuRoundedIcon />
            </IconButton>
          ) : (
            <>
              <SvgIcon
                onClick={handleDrawerOpen}
                component={Sidenavslidericon}
                inheritViewBox
                sx={{
                  position: "absolute",
                  left: "3px",
                  padding: "0",
                  width: "16px",
                  height: "16px",
                  color: "#F8F9FA",
                  cursor: "pointer",
                }}
              />
              {details?.role === "STUDENT" ? (
                <span className="pathnamecurrentlist">
                  <span className="pathnamecurrent">Page /</span> {pageTitle}
                </span>
              ) : (
                <div></div>
              )}
            </>
          )}

          <UserProfileSection />
          <Drawer
            open={themeSettingsOpen}
            onClose={() => setThemeSettingsOpen(false)}
            anchor={"right"}
            sx={{
              "& .MuiDrawer-paper": {
                padding: "8px",
                width: drawerWidth,
              },
            }}
          >
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              {[
                { primary_color: "#00bfff" },
                { primary_color: "#f00" },
                { primary_color: "#ff00fb" },
                { primary_color: "#ff000f" },
                { primary_color: "#259116" },
              ].map((palateColor) => {
                return (
                  <div
                    onClick={() => {
                      setTheme(palateColor.primary_color, "--primary-color");
                      dispatch(
                        themeUpdate({
                          primary_color: palateColor.primary_color,
                        })
                      );
                    }}
                    style={{
                      backgroundColor: palateColor.primary_color,
                      width: 30,
                      height: 30,
                    }}
                  />
                );
              })}
            </div>`
          </Drawer>
        </Toolbar>
      </AppBar> 

      {/*     Navbar     */}
      <Box
        component="nav"
        sx={{
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        <IconWithDrawer
          variant="permanent"
          open={open && !smBreackPoint}
          className="drawer"
          sx={{
            display: { xs: "none", sm: "block" },
            flexGrow: 1,
            height: "100vh",
          }}
        >
          <DrawerHeader className="drawer_header testing-class">
            <div>
              <SvgIcon
                sx={{
                  width: open ? "200px" : 100,
                  height: open ? "45px" : 50,
                  margin: open ? "20px 5px 0px 0px" : "0px",
                  fill: "currentcolor",
                  cursor: "pointer",
                }}
                color="primary"
                component={open ? Logo : MiniLogo}
                inheritViewBox
                onClick={() => {
                  nav(dashboardPath);
                }}
              />
            </div>
            {/* <SvgIcon
              onClick={handleDrawerOpen}
              component={Sidenavslidericon}
              inheritViewBox
              sx={{
                position: "absolute",
                left: "3px",
                padding: "0",
                width: "16px",
                height: "16px",
                color: "#F8F9FA",
                cursor: "pointer",
              }}
            /> */}
          </DrawerHeader>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: Dashboarduser?.is_subscribed === true ? "100%" : "90%",
            }}
          >
            {/* Scrollable Drawer List */}
            <Box
              className="navsidebar"
              sx={{
                flex: 1,
                overflowY: "auto",
                // px: 2,
                mt: 1,
                borderTop: "1px solid #e5e7eb",
                borderBottom: "1px solid #e5e7eb",

                // // Scrollbar style
                // "&::-webkit-scrollbar": {
                //   width: "4px",
                // },
                // "&::-webkit-scrollbar-thumb": {
                //   backgroundColor: "#b9b9b9",
                //   borderRadius: "4px",
                // },
                // "&::-webkit-scrollbar-thumb:hover": {
                //   backgroundColor: "#919191",
                // },
                // "&::-webkit-scrollbar-track": {
                //   background: "#f1f1f1",
                // },
              }}
            >
              {drawer}
            </Box>

            {Dashboarduser?.is_subscribed === false &&
              details?.role === "STUDENT" &&
              open && (
                <Box
                  className="gradient-cardsidenavbar"
                  sx={{
                    px: 2,
                    pb: 2,
                    background: "#ffeaea", // light red background
                    borderTop: "1px solid #e0e0e0",
                  }}
                >
                  <Box className="inner-card">
                    <SvgIcon
                      sx={{
                        width: 200,
                        height: 40,
                        fill: "#1D7DFF", // red icon color
                      }}
                      // color="error"
                      component={Subscription}
                      inheritViewBox
                    />
                    <Typography className="upgradeaccount">
                      Upgrade your account
                    </Typography>
                    <Typography variant="body1" className="upgradepremium">
                      Join our Weekly Course & Get access to Premium Features!
                    </Typography>

                    {Subcriptiondetails?.status === false ? (
                      <Button
                        className="button"
                        sx={{ color: "black" }}
                        onClick={() => setOpenPricing(true)}
                      >
                        Subscribe Now
                      </Button>
                    ) : (
                      <Button
                        className="button"
                        sx={{
                          color: "black",
                          backgroundColor:
                            isSubscriptionProcessing ? "grey !important" : "white",
                          "&:hover": {
                            backgroundColor: (isSubscriptionProcessing ? "grey !important" : "white"),
                          },
                        }}
                        onClick={() => setOpenPricing(true)}
                      /*
                      onClick={() => {
                        dispatch(clearListSubscription());
                        dispatch(AddSubscription());
                        dispatch(
                          listSubscription({
                            package_id: Packages[0]?.package_id,
                          })
                        );
                      }}
                      */
                      >
                        {isSubscriptionProcessing ? (
                          <>
                            <CircularProgress size={24} color="inherit" />
                            <span style={{ marginLeft: "10px" }}>Please wait ...</span>
                          </>
                        ) : (
                          "Subscribe Now"
                        )}
                      </Button>
                    )}
                  </Box>
                </Box>
              )}
          </Box>
        </IconWithDrawer>

        {/* mobile screen drawer */}
        <Drawer
          variant="temporary"
          className="drawer"
          open={mobileOpen && smBreackPoint}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <DrawerHeader className="drawer_header">
            <>
              <SvgIcon
                sx={{
                  width: !open ? 100 : "200px",
                  height: !open ? 50 : "40px",
                  margin: !open ? "0px" : "20px 30px 0px 0px",
                  fill: "currentcolor",
                }}
                color="primary"
                component={MiniLogo}
                inheritViewBox
              />
            </>
          </DrawerHeader>
          {/* <Divider /> */}
          {drawer}
        </Drawer>
      </Box>

      {/*     Main content     */}
      <Box
        component="main"
        className="mainSection"
        ref={mainRef}
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          // height: "100%",
          height: "fit-content",
        }}
      >
        {/*     for header space     */}
        {/* <DrawerHeader className="drawer_header" /> */}

        {/*     main content     */}
        {/* <TestArea /> */}
        <Drawer open={moblieDrawerOpen}>
          <DrawerHeader className="drawer_header">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingRight: "10px",
              }}
            >
              <SvgIcon
                sx={{
                  width: "150px",
                  height: "40px",
                  margin: "20px 30px 0px 0px",
                  fill: "currentcolor",
                }}
                color="primary"
                component={MobileLogo}
                inheritViewBox
              />
              <div
                style={{ fontSize: "18px" }}
                onClick={() => setMoblieDrawerOpen(false)}
              >
                ✖
              </div>
            </div>
          </DrawerHeader>
          {drawer}
        </Drawer>
        <div className="mobile_drawer">
          <SvgIcon
            sx={{
              width: "150px",
              height: "40px",
              margin: "20px 30px 0px 0px",
              fill: "currentcolor",
            }}
            color="primary"
            component={MobileLogo}
            inheritViewBox
          />
          <div
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={() => setMoblieDrawerOpen(moblieDrawerOpen ? false : true)}
          >
            {moblieDrawerOpen ? "✖" : "☰"}
          </div>
        </div>
        <div className="mainContent" style={{ height: '100%' }}>
          <Outlet />
        </div>
      </Box>

      {/*     Search     */}
      <SearchPopup dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />

      <PricingDialog
        open={openPricing}
        onClose={() => setOpenPricing(false)}
        isUCAT={isUCAT}
        Packages={Packages}
        isSubscriptionProcessing={isSubscriptionProcessing}
        setPricingChecked={setPricingChecked}
      />
    </Box>
  );
}

/*    check if it has child or not     */
function hasChildren(item: IMenuItem) {
  const { items: children } = item;

  if (children === undefined) {
    return false;
  }

  if (children.constructor !== Array) {
    return false;
  }

  if (children.length === 0) {
    return false;
  }

  return true;
}

const isChildActive = (item: IMenuItem, currentPath: string): boolean => {
  if (item.to && currentPath.split("/").includes(item.to.replace(/^\/+/, ""))) {
    return true;
  }
  if (item.items && item.items.length > 0) {
    return item.items.some((child) => isChildActive(child, currentPath));
  }
  return false;
};



const MenuItems: React.FC<{
  item: IMenuItem;
  mini: boolean;
  child?: boolean;
  setMobileOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setMoblieDrawerOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ item, mini, child = false, setMobileOpen, setMoblieDrawerOpen }) => {
  const resolvedItem = {
    ...item,
    icon: getDynamicIcon(item.icon),
    // icon: svgs[item.icon as string ?? "Dashboard"] ?? svgs["Dashboard"], // Reverted to getDynamicIcon
  };

  const Component = hasChildren(resolvedItem) ? MultiLevel : SingleLevel;
  return (
    <Component
      item={resolvedItem}
      mini={mini}
      child={child}
      setMobileOpen={setMobileOpen}
      setMoblieDrawerOpen={setMoblieDrawerOpen}
    />
  );
};

const SingleLevel: React.FC<{
  item: IMenuItem;
  mini: boolean;
  child: boolean;
  setMobileOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setMoblieDrawerOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ item, mini, child, setMobileOpen, setMoblieDrawerOpen }) => {
  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );

  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  return (
    <ListItem disablePadding>
      <ListItemButton
        component={IsActiveLink}
        to={item.to!}
        className={mini ? "miniListButton" : "listButton"}
        sx={{ flexDirection: mini ? "column" : "row" }}
        activeClassName={child ? "activeSubMenu xxx" : "activeMenu xxx"}
        onClick={() =>
          setMobileOpen && setMoblieDrawerOpen
            ? (setMobileOpen(false), setMoblieDrawerOpen(false))
            : undefined
        }
        end
      >
        <ListItemIcon sx={{ minWidth: "0", marginRight: mini ? "0" : "8px" }}>
          {item.icon as React.ReactNode}
          {/* {item.icon && <SidebarIcon src={item.icon as string} className="sidebar-icon" />} */}
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{
            className: "listText",
            sx: { fontSize: mini ? "0.7rem" : "1rem" },
          }}
          primary={item.title}
        // sx={{ whiteSpace: mini ? "nowrap" : "pre-wrap" }}
        />
      </ListItemButton>
    </ListItem>
  );
};

// MultiLevel Component
const MultiLevel: React.FC<{
  item: IMenuItem;
  mini: boolean;
  setMobileOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ item, mini, setMobileOpen }) => {
  const { items: children } = item;
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(!open);
    setAnchorEl(open ? null : event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  let handleOutsideClick = (event: MouseEvent) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target as Node)
    ) {
      handleClose();
    }
    // handleClose();
  };

  React.useEffect(() => {
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const location = useLocation();
  const currentPath = location.pathname;

  const isSelected = (path: string | undefined) => {
    if (!path) return false;
    return currentPath.split("/").includes(path.replace(/^\/+/, ""));
  };

  React.useEffect(() => {
    if (isChildActive(item, currentPath)) {
      setOpen(true);
    } else {
      setOpen(false);
    }
    if (mini) {
      handleClose();
    }
  }, [currentPath, mini]);

  // const isMainActive = isSelected(item.to);
  // const isParentActive = isChildActive(item, currentPath);

  const isMainActive = isSelected(item.to);
  const isParentActive = isChildActive(item, currentPath);

  const activeClass = isSelected(item.to)
    ? "activeMenu"
    : isChildActive(item, currentPath)
      ? "parentActive"
      : "";

  return (
    <React.Fragment>
      <ListItem onClick={handleClick} disablePadding>
        <ListItemButton
          selected={isMainActive}
          className={
            mini
              ? `miniListButton ${isMainActive ? "activeMenu" : ""} ${isParentActive ? "parentActive" : ""
              }`
              : `listButton ${isMainActive ? "activeMenu" : ""} ${isParentActive ? "parentActive" : ""
              }`
          }
          sx={{
            flexDirection: mini ? "column" : "row",
          }}
        >
          <ListItemIcon sx={{ minWidth: "0", marginRight: mini ? "0" : "8px" }}>
            {item.icon as React.ReactNode}
            {/* {item.icon && <SidebarIcon src={item.icon as string} className="sidebar-icon" />} */}
            {mini && (open ? <NavigateBeforeIcon /> : <NavigateNextIcon />)}
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{
              className: "listText",
              sx: { fontSize: mini ? "0.7rem" : "1rem" },
            }}
            primary={item.title}
          // sx={{ whiteSpace: mini ? "nowrap" : "pre-wrap" }}
          />
          <ListItemIcon sx={{ justifyContent: "flex-end", minWidth: 0 }}>
            {!mini && (open ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
      {mini ? (
        // mini screen
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Paper>
            <List>
              {children?.map((child, key: number) => {
                return (
                  child.permissions?.show &&
                  child.permissions?.view && (
                    <React.Fragment key={key}>
                      {child.to && !child.items?.length ? (
                        <ListItemButton
                          component={IsActiveLink}
                          activeClassName={"activeSubMenu"}
                          className={
                            !!isSelected(child.to) ? "activeSubMenu sss" : "sss"
                          }
                          to={child.to}
                          onClick={(event) => {
                            handleOutsideClick(event as unknown as MouseEvent);
                            setMobileOpen && setMobileOpen(false);
                          }}
                        >
                          <ListItemText
                            primaryTypographyProps={{
                              className: "listText",
                              sx: { fontSize: mini ? "0.7rem" : "1rem" },
                            }}
                            primary={child.title}
                          />
                        </ListItemButton>
                      ) : (
                        <MenuItems key={key} item={child} mini={mini} />
                      )}
                    </React.Fragment>
                  )
                );
              })}
            </List>
          </Paper>
        </Popover>
      ) : (
        // main screen
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 1 }}>
            {children?.map(
              (child, key: number) =>
                child.permissions?.show &&
                child.permissions?.view && (
                  <MenuItems
                    key={key}
                    item={child}
                    mini={mini}
                    child={!!item.items}
                    setMobileOpen={setMobileOpen}
                  />
                )
            )}
          </List>
        </Collapse>
      )}
    </React.Fragment>
  );
};
